const STANDARDCUBICBEZIER = "cubicBezier(0.35, 1, 0.45, 1)";

export { STANDARDCUBICBEZIER };
